import { type Subscription, TierType } from '@getstep/proto/tier'
import { notNullish, nullish } from '@getstep/sdk/dist/util/Assert'
import { useEffectAsync } from '@lib/hooks/useEffectAsync'
import { OnboardingContext } from '@lib/store/onboarding/context'
import { OnboardingStore } from '@lib/store/onboarding/OnboardingStore'
import { useSession } from '@lib/store/useStores'
import { useContext, useState } from 'react'

export const useOnboarding = () => {
    const onboardingValue = useContext(OnboardingContext)
    const [onboarding] = useState(onboardingValue ?? new OnboardingStore())
    return onboarding
}

export const useTierCatalogSubscriptionInfo = () => {
    const { authorizedStore } = useSession()
    const [subscription, setSubscription] = useState<Subscription | undefined>(
        undefined,
    )
    useEffectAsync(async () => {
        if (nullish(subscription)) {
            const response = await authorizedStore?.tierStore?.getTierCatalog()
            if (notNullish(response)) {
                setSubscription(
                    response.find((tier) => tier.type === TierType.BLACK)
                        ?.subscription,
                )
            }
        }
    })

    return subscription
}
